import { useEffect } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import styles from "./Stores.module.css";
import Link from "next/link";
import { getSanityNextImage } from "@lib/getImages";
import { trackEvent } from "@lib/track-event";
import { Layout } from "@components/Layout/index";
import { getAllStores, getModalSettings, getGlobalConfig } from "@lib/api/calls";
import { StoreCard } from "@components/Store/StoreCard";

function getStoreImage(store) {
  if (!store.meta || !store.meta.openGraphImage) {
    return null;
  }
  let href = {
    pathname: "/stores/[slug]",
    query: { slug: store.slug.current },
  };

  return (
    <Link href={href}>
      {getSanityNextImage(
        store.meta.openGraphImage,
        { small: "800", medium: "600", large: "900" },
        `${store.city} storefront`
      )}
    </Link>
  );
}

export default function Index({ preview, title, seo, stores, config, subscribed, modal }) {
  const { t } = useTranslation("store");
  useEffect(() => {
    trackEvent("view_page", {
      pageTitle: title,
      pageCategory: "Information Page",
      pageLocation: window.location.href,
      pagePath: window.location.pathname,
    });
  }, []);

  return (
    <Layout
      config={config}
      title={title}
      seo={seo}
      subscribed={subscribed}
      isPreview={preview}
      modal={modal}
      pageFound={true}
    >
      <main className={styles.content}>
        <header className={styles.header}>
          <h1>{t("title")}</h1>
        </header>

        {stores.map((store) => (
          <div className={styles.cardWrapper} key={store.key}>
            <div className={styles.imageWrapper}>{getStoreImage(store)}</div>
            <StoreCard store={store} isIndex />
          </div>
        ))}
      </main>
    </Layout>
  );
}

export async function getStaticProps({ preview = false, locale }) {
  const modal = await getModalSettings(locale, preview);
  const config = await getGlobalConfig(locale, preview);
  const stores = await getAllStores(preview);
  let cities = "";

  stores?.map((store, index) => {
    if (index === stores.length - 1) {
      cities = `${cities}or ${store.city}`;
    } else {
      cities = `${cities + store.city}, `;
    }
  });

  const seo = {
    seoTitle: `Kotn · Our Stores`,
    seoDescription: `If you are in ${cities} you can shop at our retail stores. Get directions, store hours, and more.`,
    openGraphImage: stores[0]?.meta?.openGraphImage || null,
    twitterCard: "summary_large_image",
  };

  return {
    props: {
      preview,
      title: `Our Stores`,
      seo,
      stores: stores || null,
      modal,
      config,
      ...(await serverSideTranslations(locale, ["common", "navbar", "footer", "store", "cart"])),
    },
    revalidate: 1800,
  };
}
